import { Component, ChangeDetectionStrategy, Input } from "@angular/core";

import { Validity } from "../store/validity/state";

@Component({
    selector: "zbd-validity-indicator",
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: ` <span [ngClass]="getClasses()"></span> `,
    styles: [
        `
            .zbd-indicator {
                display: inline-block;
                vertical-align: middle;
                width: 30px;
                height: 25px;
                line-height: 25px;
                text-align: center;
            }
            .zbd-indicator.zbd-small {
                width: 25px;
                height: 20px;
                line-height: 20px;
            }

            .zbd-indicator.zbd-invalid {
                font-size: 10px;
                color: #ea635c;
            }
            .zbd-indicator.zbd-invalid.zbd-small {
                font-size: 8px;
            }

            .zbd-indicator.zbd-valid {
                font-size: 24px;
                color: #00bfb3;
            }
            .zbd-indicator.zbd-valid.zbd-small {
                font-size: 20px;
            }
        `,
    ],
})
export class ZbdValidityIndicatorComponent {
    @Input() validity: Validity;
    @Input() small = false;

    public getClasses(): string {
        let cls = "zbd-indicator";
        if (this.small || true) {
            cls += " zbd-small";
        }
        if (this.validity) {
            cls += this.validity.valid
                ? " icon-hook zbd-valid"
                : " icon-dot-indicator-three zbd-invalid";
        }
        return cls;
    }
}
